/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { BIDashboardPage } from '@/pages/Reports/BIDashboardPage';

export function BIDashboardRoute() {
  return <BIDashboardPage />;
}
